import React, {Fragment, useContext, useState} from 'react';
import {Btn, H4, P} from '../../../../AbstractElements';
import {Form, FormGroup, Label} from 'reactstrap';
import {Link, useNavigate} from 'react-router-dom';
import axiosConfig from '../../../../Config/axios';
import {useForm} from "react-hook-form";
import TextInput from "../../../../CommonElements/Input/TextInput";
import Loader from "../../../../Layout/Loader";
import {ToastContainer} from "react-toastify";
import {getAuthenticationRoute} from "../../../../Route/RouteIndex";
import AuthorizationContext from "../../../../_helper/Authorization";
import type {AuthorizationContextType} from "../../../../_helper/Authorization/AuthorizationTypes";

const LoginForm = () => {
    const [togglePassword, setTogglePassword] = useState(false);
    const [loaderVisibility, setLoaderVisibility] = useState(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        setError,
        formState: {errors},
    } = useForm();

    const onSubmit = (data) => {
        setLoaderVisibility(true);
        localStorage.removeItem("authenticated");
        localStorage.removeItem("authenticated_user");
        localStorage.removeItem("authenticated_token");
        axiosConfig
            .post(`${getAuthenticationRoute('login')}`, data)
            .then(response => {
                if (response?.data?.data?.requires_2fa) {
                    // Store email and temp token for 2FA verification
                    localStorage.setItem("2fa_email", data.email);
                    localStorage.setItem("2fa_temp_token", response.data.data.two_factor_temp_token);
                    setLoaderVisibility(false);
                    navigate(`${process.env.PUBLIC_URL}/verify-2fa`);
                } else if (response?.data?.data) {
                    localStorage.setItem("authenticated_user", JSON.stringify(response.data.data.user));
                    localStorage.setItem("authenticated_token", response.data.data.token);
                    document.location.href = `${process.env.PUBLIC_URL}/`;
                }
                setLoaderVisibility(false);
            })
            .catch(exception => {
                setLoaderVisibility(false);
                errorHandler(exception, setError);
            });
    }
    return (
        <Fragment>
            <div className='login-card'>
                <div className='login-main'>
                    <Loader visibility={loaderVisibility}/>
                    <Form onSubmit={handleSubmit(onSubmit)}
                          className='theme-form login-form'>
                        <H4>Sign in to account</H4>
                        <P>Enter your email & password to login</P>
                        <TextInput name={'email'} type={'email'} label={'Email Address'} register={register}
                                   errors={errors} placeholder={'Test@gmail.com'} options={{required: true}}/>
                        <FormGroup className='position-relative'>
                            <Label className='col-form-label m-0'>Password</Label>
                            <div className='position-relative'>
                                <input className='form-control' type={togglePassword ? 'text' : 'password'}
                                       name={'password'} {...register('password', {required: true})}
                                       placeholder='*********'/>
                                <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)}>
                                    <span className={togglePassword ? '' : 'show'}></span>
                                </div>
                            </div>
                            <span className='d-block'>{errors.password && errors.password.message}</span>
                            <div className='invalid-feedback'>{'Please provide a valid password'}</div>
                        </FormGroup>
                        <FormGroup className='position-relative'>
                            <div className='checkbox'>
                                <input id='remember_me' type='checkbox'
                                       name={'remember_me'} {...register('remember_me')}/>
                                <Label className='text-muted' for='remember_me'>
                                    Remember password
                                </Label>
                            </div>
                            <Link className='link' to={`${process.env.PUBLIC_URL}/forget-password`}>
                                Forgot password?
                            </Link>
                        </FormGroup>
                        <FormGroup>
                            <Btn attrBtn={{className: 'd-block w-100 mt-2', color: 'primary', type: 'submit',}}>Sign
                                in</Btn>
                        </FormGroup>
                    </Form>
                </div>
                <ToastContainer/>
            </div>
        </Fragment>
    );
};

export default LoginForm;
